import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { MasterClientProductViewDto } from '../../../models/api-data-contracts';
import { MatIconModule } from '@angular/material/icon';
import { calculatePlanRate, calculatePlanRateWithDiscount, paymentFrequencyName } from '../../../common/helpers';

@Component({
  selector: 'app-plans-summary',
  imports: [CommonModule, MatIconModule],
  templateUrl: './plans-summary.component.html',
  styleUrl: './plans-summary.component.scss'
})
export class PlansSummaryComponent {
  @Input({required: true}) products: MasterClientProductViewDto[] = [];
  @Input({required: true}) paymentFrequency: number = 1;
  @Input({required: true}) discountApplied: number = 0;

  planRate(plan: MasterClientProductViewDto): number {
    return (plan.memberContribution ?? 0) * this.paymentFrequency;
  }

  planRateWithDiscount(plan: MasterClientProductViewDto): number {
    const rate = this.planRate(plan);
    return rate * (1 - this.discountApplied / 100);
  }

  totalPrice(): number {
    return this.products.reduce((sum, plan) => sum + this.planRate(plan), 0);
  }

  totalPriceWithDiscount(): number {
    return this.products.reduce((sum, plan) => sum + this.planRateWithDiscount(plan), 0);
  }

  paymentFrequencyName(): string {
    return paymentFrequencyName(this.paymentFrequency);
  }

  get discount(): number {
    return this.discountApplied;
  }
}
